<ion-content class="relative">
  <form (ngSubmit)="bind()" class="padding-bottom">
    <ion-list>
      <ion-item *ngIf="isAdmin">
        <app-owner-select></app-owner-select>
      </ion-item>
      <ion-item>
        <app-project-select></app-project-select>
      </ion-item>
      <ion-item>
        <app-zone-select></app-zone-select>
      </ion-item>
      <ion-item>
        <app-level-select></app-level-select>
      </ion-item>
      <ion-item>
        <app-group-select></app-group-select>
      </ion-item>
      <ion-item>
        <app-labels-select></app-labels-select>
      </ion-item>
      <div [formGroup]="groupSettings">
        <ion-item>
          <ion-input
            name="sensors"
            type="number"
            class="ion-text-right"
            formControlName="sensorsControl"
            (change)="selectNumberOfSensors()"
            label="Number of sensors"
          ></ion-input>
        </ion-item>
        <ion-item *ngIf="showIntervalPlacing">
          <ion-label>Interval (m)</ion-label>
          <ion-input
            name="interval"
            type="number"
            class="ion-text-right"
            formControlName="selectedIntervalMControl"
          ></ion-input>
        </ion-item>
      </div>
    </ion-list>
    <div class="bottom">
      <ion-button
        expand="full"
        [disabled]="disableSubmit()"
        type="submit"
      >set positions</ion-button>
    </div>
  </form>
</ion-content>
